export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
  href?: string
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'home',
      displayName: 'menu.home',
      meta: {
        icon: 'home',
      },
    },
    {
      name: 'sponsored',
      displayName: 'menu.sponsored',
      meta: {
        icon: 'campaign',
      },
    },
    {
      name: 'fanpage',
      displayName: 'menu.fanpage',
      meta: {
        icon: 'favorite',
      },
    },
    {
      name: 'group',
      displayName: 'menu.group',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'profile',
      displayName: 'menu.profile',
      meta: {
        icon: 'person',
      },
    },
    {
      name: 'review',
      displayName: 'menu.review',
      meta: {
        icon: 'star',
      },
      href: 'https://review.fblead.net/',
    },
  ] as INavigationRoute[],
}
